export enum PopulateMode {
    manual = 0,
    duplicate = 1,
    translator = 2,
    existing = 3,
    autoTranslator = 4,
    suggestedReuse = 5,
    suggestedGenerated = 6,
    suggestedHuman = 7
}
